import { useQuery } from '@tanstack/react-query';

import { getTargetedCreatives } from '../api/ventura/contract';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

function useContractTargetedCreatives(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['contractTargetedCreatives', contractId],
    queryFn: () => getTargetedCreatives(apiHost, contractId),
    select: camelCaseKeys
  });

  return query;
}

export default useContractTargetedCreatives;
